import { DangerAlert } from "components/common/Alerts";
import "components/common/DatePicker.css";
import JobSelect from "components/common/JobSelect";
import serialize from "form-serialize";
import * as moment from "moment";
import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaskedInput from "react-text-mask";
import apifetch from "utils/apifetch";
import createNumberMask from "utils/createNumberMask";
import extractErrorMessage from "utils/extractErrorMessage";
import normalizePrice from "utils/normalizePrice";


interface Props {
    onSubmit?: Function;
    data?: any;
    salespersonInput?: HTMLInputElement;
}

interface State {
    addNew: boolean;
    bidDate?: moment.Moment;
    hasValidationErrors: boolean;
    validationMessage: string;
    files: any[];
    jobId: number;
}

export default class Step1Job extends React.Component<Props, State> {
    private baseUrl: string;
    private formRef: React.RefObject<HTMLFormElement>;
    private jobSelectRef: React.RefObject<JobSelect>;

    public constructor(props: Props) {
        super(props);

        this.state = {
            addNew: false,
            hasValidationErrors: false,
            validationMessage: "",
            files: [],
            jobId:
                this.props.data && this.props.data.jobId ? this.props.data.jobId : 0,
        };

        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;
        this.formRef = React.createRef();
        this.jobSelectRef = React.createRef();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBidDateChanged = this.handleBidDateChanged.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.handleAddNewChanged = this.handleAddNewChanged.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <form id="add-job" name="form" className="form" ref={this.formRef}>
                <div>
                    {this.state.hasValidationErrors && (
                        <DangerAlert name="dangerAlert">
                            {this.state.validationMessage || "An error occured."}
                        </DangerAlert>
                    )}
                    <div className="row">
                        <div className="field-group col-sm-12 mt-3 mb-3">
                            <span className="field-label mt-0">New Project</span>
                            <p className="custom-checkbox-wrap">
                                <input
                                    className="custom-checkbox"
                                    id="add-new-job-yes"
                                    name="addNewJob"
                                    type="radio"
                                    value="true"
                                    onClick={this.handleAddNewChanged}

                                />
                                <label htmlFor="add-new-job-yes">Yes</label>
                            </p>
                            <p className="custom-checkbox-wrap">
                                <input
                                    className="custom-checkbox"
                                    id="add-new-job-no"
                                    name="addNewJob"
                                    type="radio"
                                    value="false"
                                    onClick={this.handleAddNewChanged}
                                    defaultChecked={true}
                                />
                                <label htmlFor="add-new-job-no">No</label>
                            </p>
                        </div>
                    </div>
                    {this.state.addNew ? (
                        <div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">CIS #</span>
                                    <input
                                        type="text"
                                        name="cisNumber"
                                        className="form-control"
                                        id="cis-id"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Bid Date</span>
                                    <DatePicker
                                        name="bidDate"
                                        selected={this.state.bidDate}
                                        onChange={this.handleBidDateChanged}
                                        dateFormat="LL"
                                        className="form-control"
                                        popperPlacement="bottom"
                                        popperModifiers={{
                                            flip: {
                                                behavior: ["bottom"],
                                            },
                                            preventOverflow: {
                                                enabled: false,
                                            },
                                            hide: {
                                                enabled: false,
                                            },
                                        }}
                                    />
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Type</span>
                                    <select
                                        name="jobTypeId"
                                        id="type"
                                        className="form-control select2-single"
                                    >
                                        <option value="">Select a type</option>
                                        <option value="1">Public</option>
                                        <option value="2">Private</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Project Name</span>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        id="job-name"
                                        required
                                        onInput={(e) => e.currentTarget.setCustomValidity("")}
                                        onInvalid={(e) =>
                                            e.currentTarget.setCustomValidity("Project name is required.")
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Description</span>
                                    <textarea
                                        name="description"
                                        id="description"
                                        rows={6}
                                        className="form-control"
                                    ></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-4">
                                    <span className="field-label">Estimated Cost</span>
                                    <MaskedInput
                                        mask={numberMask}
                                        name="costEstimate"
                                        className="form-control"
                                        id="estimated-cost"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Address</span>
                                    <input
                                        type="text"
                                        name="address"
                                        className="form-control"
                                        id="address"
                                        maxLength={50}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Address 2</span>
                                    <input
                                        type="text"
                                        name="address2"
                                        className="form-control"
                                        id="address"
                                        maxLength={50}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">City</span>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        id="city"
                                        maxLength={50}
                                        required
                                        onInput={(e) => e.currentTarget.setCustomValidity("")}
                                        onInvalid={(e) =>
                                            e.currentTarget.setCustomValidity("City is required.")
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">State</span>
                                    <input
                                        type="text"
                                        name="state"
                                        className="form-control"
                                        id="state"
                                        pattern="[A-Za-z]{2}"
                                        maxLength={2}
                                        onInput={(e) => e.currentTarget.setCustomValidity("")}
                                        onInvalid={(e) =>
                                            e.currentTarget.setCustomValidity(
                                                "State must be a 2 character abbreviation."
                                            )
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">County</span>
                                    <input
                                        type="text"
                                        name="county"
                                        className="form-control"
                                        id="county"
                                        maxLength={50}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Project Name</span>
                                    {this.props.data.jobId ? (
                                        <JobSelect
                                            ref={this.jobSelectRef}
                                            value={{
                                                value: this.props.data.jobId,
                                                label: this.props.data.jobName,
                                            }}
                                            includeInternal={true}
                                        />
                                    ) : (
                                        <JobSelect ref={this.jobSelectRef} includeInternal={true} />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </form>
        );
    }

    public async handleSubmit(data: any, onSubmitCallback: Function) {
        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
                validationMessage: "",
            });
        }

        if (this.state.addNew) {
            if (!this.formRef.current!.checkValidity()) {
                this.setState({
                    hasValidationErrors: true,
                    validationMessage: "One or more fields are invalid.",
                });
                return;
            }

            let newData = serialize(this.formRef.current!, { hash: true }) as any;

            newData.salesPerson = data.salesPerson;

            // Normalize estimated cost to 0000.00
            if (newData.costEstimate) {
                newData.costEstimate = normalizePrice(newData.costEstimate);
            }

            let response = await apifetch(
                "jobs",
                {
                    headers: new Headers({
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    }),
                    method: "POST",
                    body: JSON.stringify(newData),
                },
                true
            );
            if (response.ok) {
                let responseData = await response.json();
                data.jobId = responseData.id;
                data.jobName = newData.name;

                onSubmitCallback(data);
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    hasValidationErrors: true,
                    validationMessage: errorText,
                });
            }
        } else {
            let job = this.jobSelectRef.current!.getJob();
            if (job === null) {
                this.setState({
                    hasValidationErrors: true,
                    validationMessage:
                        "You must add a new project or select an existing project.",
                });
                return;
            }

            data.jobId = job.id;
            data.jobName = job.name;

            onSubmitCallback(data);
        }
    }

    private handleBidDateChanged(date: moment.Moment) {
        this.setState({
            bidDate: date,
        });
    }

    private onDrop(acceptedFiles: any, rejectedFiles: any) { }

    private handleAddNewChanged(e: any) {
        this.setState({
            addNew: e.target.value === "true",
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/Step1Job.tsx